import groq from "groq";
import type * as Schema from "../types/schema";
import { getExcludeDraftsFilter } from "../queries/filters";
import { FilterCategory, FilterOption } from "../types/filterManager";
import { getSingleDocumentData } from "../utils/getSingleDocumentData";
import { cmsQuery, CMSResult } from "./cmsClient";
import { Ok } from "@pairtreefamily/utils";
import { QueryableSanityData } from "../types/sanity";
import { SEOPageData } from "@/types/seoPageData";

export type InsightsLandingData = Pick<
  Schema.InsightsLanding,
  "_id" | "heading" | "subheading"
> & {
  filterData: Array<
    FilterCategory & {
      _id: string;
      options: Array<FilterOption>;
    }
  >;
} & SEOPageData;

export type GetInsightsLandingQueryArgs = {
  preview?: boolean;
};

export const getInsightsLandingQuery = (preview?: boolean) => groq`
  *[_type == "insightsLanding" && ${getExcludeDraftsFilter(preview)}]{
    _id,
    heading,
    subheading,
    seo,
    "filterData": filters[]->{
      _id,
      value,
      displayName,
      "options": *[_type == "filterOption" && category._ref == ^._id]{
        value,
        displayName,
      }
    }
  }
`;

export async function getInsightsLanding(
  preview?: boolean,
): Promise<CMSResult<QueryableSanityData<InsightsLandingData>>> {
  const query = getInsightsLandingQuery(preview);

  const insightsLandingResult = await cmsQuery<InsightsLandingData>({
    preview,
    query,
  });

  const data = getSingleDocumentData(insightsLandingResult, preview);

  if (!data.ok) {
    return data;
  }

  return Ok({
    query,
    data: data.content,
  });
}
